import React, { useState } from "react";
import { useMarketingCopy } from "./MarketingShell";
import workspaceCopy from "./productWorkspaceCopy.json";

function SourceIcon({ kind }: { kind: string }) {
  return <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {kind === "database" ? <><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 4 16 4 16 0V5M4 12c0 4 16 4 16 0" /></> :
      kind === "mic" ? <><rect x="9" y="2" width="6" height="13" rx="3" /><path d="M5 11v1a7 7 0 0 0 14 0v-1M12 19v3M8 22h8" /></> :
      kind === "mail" ? <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 6 9 7 9-7" /></> :
      kind === "crm" ? <><circle cx="9" cy="7" r="3" /><path d="M3 21v-3a6 6 0 0 1 12 0v3M17 4a3 3 0 0 1 0 6M19 21v-4a6 6 0 0 0-2-4" /></> :
      <><path d="M5 2h9l5 5v15H5ZM14 2v6h5M8 12h8M8 16h6" /></>}
  </svg>;
}

// An explorable enterprise ingestion example; it does not access a live account.
export default function ProductWorkspace() {
  const { language } = useMarketingCopy();
  const copy = (workspaceCopy[language] ?? workspaceCopy.en).dashboard;
  const [filter, setFilter] = useState(0);
  const [selected, setSelected] = useState("crm");
  const visibleSources = copy.sources.filter(source => filter === 0 || source.group === filter);
  const active = copy.sources.find(source => source.id === selected) ?? copy.sources[0];
  return <div className="product-data-workspace">
    <div className="product-workspace-bar"><span><img src="/logo/logo.png" alt="" width="20" height="24" /> YouWo <span aria-hidden="true">/</span> {copy.title}</span><span>{copy.exampleLabel}</span></div>
    <div className="product-workspace-heading"><h3>{copy.title}</h3><p>{copy.subtitle}</p></div>
    <div className="product-source-filters" role="group" aria-label={copy.title}>
      {copy.filters.map((label, index) => <button key={label} type="button" aria-pressed={filter === index} onClick={() => {
        setFilter(index);
        const next = copy.sources.find(source => index === 0 || source.group === index);
        if (next && index !== 0 && active.group !== index) setSelected(next.id);
      }}>{label}</button>)}
    </div>
    <div className="product-data-grid">
      <div className="product-sources">
        <div className="product-source-columns" aria-hidden="true">{copy.columns.map(label => <span key={label}>{label}</span>)}</div>
        <div className="product-source-list" role="group" aria-label={copy.columns[0]}>
          {visibleSources.map(source => <button key={source.id} type="button" className="product-source-row" aria-pressed={source.id === selected} aria-controls="product-source-detail" onClick={() => setSelected(source.id)}>
            <span className="product-source-name"><SourceIcon kind={source.icon} /><span><strong>{source.name}</strong><small>{source.type}</small></span></span>
            <span className="product-source-count">{source.count}</span><span className="product-source-access">{source.access}</span>
          </button>)}
        </div>
      </div>
      <aside className="product-source-detail" id="product-source-detail" aria-live="polite" aria-atomic="true">
        <p className="product-detail-label">{copy.detailLabel}</p><div className="product-detail-icon"><SourceIcon kind={active.icon} /></div>
        <h4>{active.name}</h4><p className="product-detail-type">{active.type}</p>
        <dl><div><dt>{copy.contextLabel}</dt><dd>{active.context}</dd></div><div><dt>{copy.accessLabel}</dt><dd>{active.access}</dd></div></dl>
        <div className="product-source-use"><span>{copy.useLabel}</span><p>{active.use}</p></div>
      </aside>
    </div>
  </div>;
}
